import React from 'react';

import {
  CONTENTFUL_COMPONENT,
  CONTENTFUL_INPUT_TYPES,
  InputType,
} from '../../shared/constants';
import { IFormField, IImage, IMdBody } from '../../types/shared';

import Checkbox from '../../components/atoms/checkbox/Checkbox';
import EnrichedCheckbox from '../../components/atoms/enriched-checkbox/EnrichedCheckbox';
import FormInput from '../../components/atoms/form-input/FormInput';
import Textarea from '../../components/atoms/text-area/Textarea';

import FormFieldset from '../../components/molecules/form-field-set/FormFieldset';

export interface FormInputProps extends IFormField {
  helperMessage?: string;
  image?: IImage;
  tooltip?: IMdBody;
  contextType?: string;
  onChange?: (name: string, value: string) => void;
}

export const renderFormInput = (item: FormInputProps, key: number) => {
  if (item.__typename === CONTENTFUL_COMPONENT.formInput) {
    if (item.type === CONTENTFUL_INPUT_TYPES.textarea) {
      return (
        <Textarea
          id={item.id}
          name={item.valueId}
          value={item.value}
          placeholder={item.placeholder}
          required={item.required}
          key={key}
          label={item.label}
        />
      );
    }
    return (
      <FormInput
        id={item.id}
        label={item.label}
        name={item.valueId}
        key={key}
        placeholder={item.placeholder}
        tooltip={item.tooltip}
        required={item.required}
        value={item.value}
        type={item.type}
        context={item?.contextType}
        onChange={(event) => {
          if (item.onChange) {
            item.onChange(
              event?.currentTarget.name || '',
              event?.currentTarget.value || ''
            );
          }
        }}
      />
    );
  }
  if (item.__typename === CONTENTFUL_COMPONENT.fieldset) {
    return (
      <FormFieldset
        key={key}
        title={item.label}
        isRequired={item.required}
        name={item.valueId}
        fields={item.radiobuttons && item.radiobuttons}
        layout={item?.layout}
        inputStyle={item?.radioType}
        helperMessage={item?.helperMessage}
      />
    );
  }
  if (
    item.__typename === CONTENTFUL_COMPONENT.wizardCheckbox &&
    item.checkboxType === InputType.LEGAL_CHECKBOX
  ) {
    return (
      <Checkbox
        key={key}
        id={item.id}
        name={item.valueId}
        label={item.label}
        labelAdvanced={item.labelAdvanced?.childMarkdownRemark.rawMarkdownBody}
        isRequired={item.required}
        title={item?.descriptionLabel}
        helperMessage={item?.helperMessage}
        tooltip={item?.tooltip}
      />
    );
  }
  if (
    item.__typename === CONTENTFUL_COMPONENT.wizardCheckbox &&
    item.checkboxType === InputType.ENRICHED_CHECKBOX
  ) {
    return (
      <EnrichedCheckbox
        key={key}
        id={item.id}
        name={item.valueId}
        label={item.label}
        isRequired={item.required}
        title={item?.descriptionLabel}
        helperMessage={item?.helperMessage}
        tooltip={item?.tooltip}
        image={item?.image}
      />
    );
  }
};
